<mat-form-field class="full-width">
  <mat-label ssFormLabel></mat-label>

  <ss-password-control></ss-password-control>

  <button
    class="hide-btn"
    matSuffix
    mat-icon-button
    color="primary"
    type="button"
    [disableRipple]="true"
    (click)="toggleVisiblity($event)"
  >
    <mat-icon >
      {{ (hideTextSubject | async) ? "visibility_off" : "visibility" }}
    </mat-icon>
  </button>

  <mat-error ssFormValidationMessage></mat-error>
</mat-form-field>
